module.exports = __webpack_public_path__ + "static/img/jieshao6.cb14cd14.png";